import { ThumbsDown, ThumbsUp } from 'lucide-react'

type Props = {
  feedbackValue: 'positive' | 'negative'
  feedbackComment?: string
}

export const MessageFeedbackBadge = ({ feedbackValue, feedbackComment }: Props) => {
  const isPositive = feedbackValue === 'positive'

  return (
    <div className="mt-1 flex flex-col items-end gap-1">
      <div
        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${
          isPositive ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'
        }`}
      >
        {isPositive ? <ThumbsUp className="h-3 w-3" /> : <ThumbsDown className="h-3 w-3" />}
        {isPositive ? 'Positive feedback' : 'Negative feedback'}
      </div>
      {feedbackComment && (
        <div className="inline-flex items-center rounded-full bg-neutral-100 px-2.5 py-1 text-xs text-neutral-600">
          &ldquo;{feedbackComment}&rdquo;
        </div>
      )}
    </div>
  )
}
